import { render, staticRenderFns } from "./MeetingLayout.vue?vue&type=template&id=1961d12f&scoped=true"
import script from "./MeetingLayout.vue?vue&type=script&lang=js"
export * from "./MeetingLayout.vue?vue&type=script&lang=js"
import style0 from "./MeetingLayout.vue?vue&type=style&index=0&id=1961d12f&prod&lang=css"
import style1 from "./MeetingLayout.vue?vue&type=style&index=1&id=1961d12f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1961d12f",
  null
  
)

export default component.exports